// Coin icons from the cryptocurrency-icons package (CC0-1.0): ticker -> the
// URL of its colour SVG, bundled at build time (coinIconUrls.ts). In tests the
// map is empty and every coin falls back to its monogram.
import { ICON_URLS } from './coinIconUrls'

const ICONS: Record<string, string> = ICON_URLS

// Tickers that were renamed, or that exchanges list under another code.
const ALIASES: Record<string, string> = { pol: 'matic', xbt: 'btc', xdg: 'doge', rndr: 'render' }

/** "BTC/USDT", "XBT", "KAS.F" -> the base asset's lower-case ticker. */
export const baseTicker = (symbol: string): string =>
  symbol.split('/')[0].split('.')[0].trim().toLowerCase()

/** The icon URL for a symbol, or null when the package has none. */
export const coinIconUrl = (symbol: string): string | null => {
  const t = baseTicker(symbol)
  return ICONS[t] ?? ICONS[ALIASES[t] ?? ''] ?? null
}
